import { useRef, useCallback, useState, useEffect } from 'react';
import { useToast } from './use-toast.js';
import { socketService } from '../services/websocketService.js';

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export function useAudio() {
  const audioRef = useRef(null);
  const { toast } = useToast();
  const [isConnected, setIsConnected] = useState(socketService.isConnected());

  useEffect(() => {
    const id = setInterval(() => {
      setIsConnected(socketService.isConnected());
    }, 2000);
    return () => clearInterval(id);
  }, []);

  const playAudio = useCallback(
    async (url) => {
      try {
        if (isConnected && !/^https?:\/\//.test(url)) {
          socketService.requestAudio(url);
          return;
        }
        let audioUrl;
        if (/^https?:\/\//.test(url)) {
          audioUrl = url;
        } else {
          const res = await fetch(`${API_BASE_URL}/audio?url=${encodeURIComponent(url)}`);
          if (!res.ok) throw new Error(`Audio fetch failed: ${res.status}`);
          const blob = await res.blob();
          audioUrl = URL.createObjectURL(blob);
        }
        if (!audioRef.current) audioRef.current = new Audio();
        audioRef.current.src = audioUrl;
        await audioRef.current.play();
      } catch (err) {
        console.error('Audio playback error:', err);
        toast({
          title: 'Audio Error',
          description: 'Could not play the audio. Please try again.',
          variant: 'destructive',
        });
      }
    },
    [isConnected, toast]
  );

  return { playAudio };
} 